import Base from '../../_config/base';

class Header extends Base {
  constructor(el) {
    super(el);

    this.hamburger = el.querySelector('#hamburger-icon');
    // this.parentItem = el.querySelector('.has-children > a');
    this.searchButton = el.querySelector('.header__submenu_search');
    this.mobileSearchButton = el.querySelector('.hamburger_menu_search');
    this.searchBlock = el.querySelector('.header__search');
    this.searchCloseButton = el.querySelector('.header__search_close');
    this.searchInput = el.querySelector('.form__input input');
    this.results = el.querySelector('.search-results');
    this.searchLinks = el.querySelectorAll('.search-links');
    this.hamburgerMenu = el.querySelector('.hamburger-menu');
    this.body = document.getElementById('body');

    const url = new URL(window.location.href);
    const searchValue = this.searchInput.value.trim();

    // let timeout = null;
    // let controller = null;

    if (searchValue) {
      this.searchBlock.classList.add('active');
    }

    this.hamburger.onclick = (e) => {
      e.preventDefault();
      this.hamburger.classList.toggle('active');
      this.body.classList.toggle('overflow-hidden');
      el.classList.toggle('active');
      this.hamburgerMenu.classList.remove('active');
    };

    if (this.searchButton && this.searchBlock) {
      this.searchButton.onclick = (e) => {
        e.preventDefault();
        this.searchBlock.classList.add('active');
      };
    }

    if (this.mobileSearchButton && this.searchBlock) {
      this.mobileSearchButton.onclick = (e) => {
        e.preventDefault();
        this.searchBlock.classList.add('active');
      };
    }

    if (this.searchCloseButton && this.searchBlock) {
      this.searchCloseButton.onclick = (e) => {
        e.preventDefault();
        this.searchBlock.classList.remove('active');
        url.searchParams.delete('q');
        window.history.replaceState({}, '', url);
        this.searchInput.value = '';
      };
    }
  }
}

Header.className = 'Header';
export default Header;
